import React, { useRef, useState, useEffect } from "react";
import { IoMdClose, IoMdPlay, IoIosPause, IoMdDownload } from "react-icons/io";
import { HiMiniSpeakerWave, HiMiniSpeakerXMark } from "react-icons/hi2";

const MediaPopup = ({ open, onClose, type, src }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(true);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = isMuted;
        }
    }, [isMuted]);

    useEffect(() => {
        if (!open && videoRef.current) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }, [open]);

    const handleDownload = async () => {
        try {
            const response = await fetch(src, { mode: "cors" });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // Try to extract filename from src or fallback
            const filename = src.split("/").pop() || "download";
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert("Failed to download file.");
        }
    };

    if (!open) return null;

    return (
        <div className="absolute h-full inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="relative bg-white dark:bg-black rounded-lg m-2 p-2 flex flex-col items-center">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 bg-gray-800 text-white rounded-full p-1 z-10"
                >
                    <IoMdClose size={15} />
                </button>
                {type === "image" ? (
                    <>
                        <img src={src} alt="popup-img" className="w-[80%] h-auto rounded" />
                        {/* <button
                            onClick={handleDownload}
                            className="flex items-center gap-1 text-gray-700 px-3 py-1 rounded text-[13px] bg-gray-200 hover:bg-gray-300"
                        >
                            <IoMdDownload className="text-[18px]" />
                        </button> */}
                    </>
                ) : (
                    <div className="relative flex flex-col items-center">
                        <video
                            src={src}
                            ref={videoRef}
                            muted={isMuted}
                            controls={false}
                            autoPlay={false}
                            disablePictureInPicture
                            onPlay={() => setIsPlaying(true)}
                            onPause={() => setIsPlaying(false)}
                            className="w-[80%] h-auto rounded"
                        />
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-3 z-10">
                            <button
                                onClick={() => {
                                    if (videoRef.current) {
                                        if (isPlaying) {
                                            videoRef.current.pause();
                                        } else {
                                            videoRef.current.play();
                                        }
                                        setIsPlaying(!isPlaying);
                                    }
                                }}
                                className="bg-white/80 dark:bg-black/80 rounded-full h-8 w-8 flex items-center justify-center"
                            >
                                {isPlaying ? (
                                    <IoIosPause className="text-[20px] text-black dark:text-white" />
                                ) : (
                                    <IoMdPlay className="text-[20px] ml-[3px] text-black dark:text-white" />
                                )}
                            </button>
                            <button
                                onClick={() => setIsMuted((prev) => !prev)}
                                className="bg-white/80 dark:bg-black/80 rounded-full h-8 w-8 flex items-center justify-center"
                            >
                                {isMuted ? (
                                    <HiMiniSpeakerXMark className="text-[20px] text-black dark:text-white" />
                                ) : (
                                    <HiMiniSpeakerWave className="text-[20px] text-black dark:text-white" />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MediaPopup;
